export const DEFAULT_LOCALE = "en";
export const LOCALE_STORAGE = process.env.LOCALE_STORAGE || "RAM";
